/** Only explicitly clipped labels may overflow horizontally. Boxes, vertical
 * bounds and neighboring values must still be measured by the caller. */
export function allowsWidgetEllipsis(node: HTMLElement): boolean {
  if (!node.matches('.widget-player-job-name, .metric-label > span:last-child, .sh-kicker > span:last-child')) return false
  const style = node.ownerDocument.defaultView?.getComputedStyle(node)
  return !!style && style.textOverflow === 'ellipsis' && (style.overflowX === 'hidden' || style.overflow === 'hidden')
}
